// components/shell/FloatingOrb.tsx — Canonical Mitra Universal Companion Orb Bridge
import React from 'react';

export const FloatingOrb: React.FC = () => {
  // The canonical universal web component (<mitra-companion>) provides the floating orb
  // across all BHIV applications. Local duplicate orb is disabled to guarantee a single canonical orb.
  return null;
};

export default FloatingOrb;

